import React from "react";

import { ReactComponent as RegisterLogo } from "../../Assets/Register/register-logo.svg";

import "./Register.scss";

// import { toast } from "react-toastify";

const Register = () => {
  // const registerHandler = () => toast.info("Coming soon...");

  return (
    <section className="w-100 register-section">
      <div className="large-container d-flex flex-column align-items-center">
        {/* <RegisterLogo className="register-logo" /> */}
        {/* <h2 className="font-size-80 font-pnb my-5 text-center">Join Us.Be you.</h2> */}
        {/* <button className="register-btn zixxar-reverse-gradient" onClick={registerHandler}>
          <div className="inner-register-btn font-size-24 font-pnm">Register now</div>
        </button> */}
      </div>
    </section>
  );
};

export default Register;
